export const checkIsWhite = (color: string) => color.toUpperCase().startsWith('#FFF')
